import { mapExchange } from '@urql/vue'
import { type Exchange } from '@urql/core'

export type HeadersOrCallback =
    | Record<string, string>
    | (() => Record<string, string>)

export function addHeaderExchange(newHeaders: HeadersOrCallback): Exchange {
    return mapExchange({
        onOperation(operation) {
            let fetchOptions = operation.context.fetchOptions || {}

            if (typeof fetchOptions === 'function') {
                fetchOptions = fetchOptions()
            }

            const h =
                typeof newHeaders === 'function' ? newHeaders() : newHeaders

            const headers = fetchOptions.headers || {}
            const setter = makeSetter(headers)

            Object.entries(h).forEach((h) => {
                const [name, value] = h

                if (name.startsWith(':')) {
                    // Handling for HTTP2 headers - The GraphQL API dies if any of them are present
                    return
                }

                setter(name, value)
            })

            return {
                ...operation,
                context: {
                    ...operation.context,
                    fetchOptions: {
                        ...fetchOptions,
                        headers,
                    },
                },
            }
        },
    })
}

function makeSetter(
    headers: HeadersInit | undefined
): (name: string, value: string) => void {
    if (typeof Headers !== 'undefined' && headers instanceof Headers) {
        return (name: string, value: string) => {
            headers.set(name, value)
        }
    } else if (Array.isArray(headers)) {
        return (name: string, value: string) => {
            headers.push([name, value])
        }
    } else if (typeof headers === 'object' && !('get' in headers)) {
        return (name: string, value: string) => {
            headers[name] = value
        }
    } else {
        // eslint-disable-next-line no-console
        console.error('Unknown type of Headers')

        return () => {}
    }
}
